import { Flex, Heading, Icon, Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CardWithShadow } from './CardWithShadow';
import { ProgressBar } from './ProgressBar';

interface IScoreCard {
  labelKey: string;
  icon: any;
  value: number;
  compareValue?: number;
  [key: string]: any;
}

export const ScoreCard = ({ labelKey, icon, value, compareValue, ...restProps }: IScoreCard) => {
  const { t } = useTranslation();

  return (
    <CardWithShadow w='100%' p={6} {...restProps}>
      <Flex justifyContent='space-between' alignItems='center'>
        <Heading fontSize='sm'>{t(labelKey)}</Heading>
        <Icon as={icon} />
      </Flex>

      <Box w='100%' mt={2}>
        <ProgressBar value={value} color='brand.cyan' />
      </Box>

      {compareValue ? (
        <Box w='100%' mt={2}>
          <ProgressBar value={compareValue} color='brand.fontColor' />
        </Box>
      ) : null}
    </CardWithShadow>
  );
};
